const actionTypes = {
    LOGIN_SUCCESS:'LOGIN_SUCCESS',
    REGISTER_SUCCESS:'REGISTER_SUCCESS',
    LOGIN_FAIL:'LOGIN_FAIL',
    REGISTER_FAIL:'REGISTER_FAIL',
    LOGOUT:'LOG_OUT',

    GET_ALL_A_TRIAL_FREE_LESSON_SUCCESS:'GET_ALL_A_TRIAL_FREE_LESSON_SUCCESS',
    GET_ALL_RECRUITMENT_SUCCESS:'GET_ALL_RECRUITMENT_SUCCESS',
    GET_ALL_RECRUITMENT_FAIL:'GET_ALL_RECRUITMENT_FAIL',
    GET_ALL_A_TRIAL_FREE_LESSON_FAIL:'GET_ALL_A_TRIAL_FREE_LESSON_FAIL',

    UPDATE_ONE_FREE_LESSON_SUCCESS: 'UPDATE_ONE_FREE_LESSON_SUCCESS',
    UPDATE_ONE_FREE_LESSON_FAIL:'UPDATE_ONE_FREE_LESSON_FAIL',

    REGISTER_FREE_LESSON_SUCCESS:'REGISTER_FREE_LESSON_SUCCESS',
    REGISTER_RECRUITMENT_SUCCESS:'REGISTER_RECRUITMENT_SUCCESS',
    REGISTER_FREE_LESSON_FAIL:'REGISTER_FREE_LESSON_FAIL',
    REGISTER_RECRUITMENT_FAIL:'REGISTER_RECRUITMENT_FAIL',

    GET_COUNT_ISFREE_SUCCESS:'GET_COUNT_ISFREE_SUCCESS',
    GET_COUNT_ISFREE_FAIL:'GET_COUNT_ISFREE_FAIL',
    GET_COUNT_ISRECRUITMENT_SUCESS:'GET_COUNT_ISRECRUITMENT_SUCESS',
    GET_COUNT_ISRECRUITMENT_FAIL:'GET_COUNT_ISRECRUITMENT_FAIL',

    GET_ALL_TRUE_FREE_LESSON_SUCCESS:'GET_ALL_TRUE_FREE_LESSON_SUCCESS',
    GET_ALL_TRUE_FREE_LESSON_FAIL:'GET_ALL_TRUE_FREE_LESSON_FAIL',
    GET_ALL_FALSE_FREE_LESSON_SUCCESS:'GET_ALL_FALSE_FREE_LESSON_SUCCESS',
    GET_ALL_FALSE_FREE_LESSON_FAIL:'GET_ALL_FALSE_FREE_LESSON_FAIL',

    GET_ALL_TRUE_RECRUITMENT_SUCCESS:'GET_ALL_TRUE_RECRUITMENT_SUCCESS',
    GET_ALL_TRUE_RECRUITMENT_FAIL:'GET_ALL_TRUE_RECRUITMENT_FAIL',
    GET_ALL_FALSE_RECRUITMENT_SUCCESS:'GET_ALL_FALSE_RECRUITMENT_SUCCESS',
    GET_ALL_FALSE_RECRUITMENT_FAIL:'GET_ALL_FALSE_RECRUITMENT_FAIL',

    DELETE_RECRUITMENT_SUCCESS: 'DELETE_RECRUITMENT_SUCCESS',
    DELETE_FREE_LESSON_SUCCESS: 'DELETE_FREE_LESSON_SUCCESS',
    DELETE_RECRUITMENT_FAIL:'DELETE_RECRUITMENT_FAIL',
    DELETE_FREE_LESSON_FAIL:'DELETE_FREE_LESSON_FAIL',

    // CurrentData
    GET_CURRENT_SUCCESS: 'GET_CURRENT_SUCCESS',
    GET_CURRENT_FAIL: 'GET_CURRENT_FAIL',

    // GET ALL NEWS
    GET_ALL_NEWS_SUCCESS : 'GET_ALL_NEWS_SUCCESS',
    GET_ALL_NEWS_FAIL : 'GET_ALL_NEWS_FAIL',
    
    // Create News
    CREATE_NEWS_SUCCESS : "CREATE_NEWS_SUCCESS",
    CREATE_NEWS_FAIL : "CREATE_NEWS_FAIL",

    // GET ALL ATTRACTIVE
    GET_ALL_ATTRACTIVE_SUCCESS:"GET_ALL_ATTRACTIVE_SUCCESS",
    GET_ALL_ATTRACTIVE_FAIL:"GET_ALL_ATTRACTIVE_FAIL",

    // CREATE ATTRACTIVE
    CREATE_ATTRACTIVE_SUCCESS:'CREATE_ATTRACTIVE_SUCCESS',
    CREATE_ATTRACTIVE_FAIL:'CREATE_ATTRACTIVE_FAIL',

    // GET ONE NEW
    GET_ONE_NEW_SUCCESS:'GET_ONE_NEW_SUCCESS',
    GET_ONE_NEW_FAIL:'GET_ONE_NEW_FAIL'
}

export default actionTypes;